import { render } from "./AccessPage.vue?vue&type=template&id=79e52154&scoped=true"
import script from "./AccessPage.vue?vue&type=script&lang=js"
export * from "./AccessPage.vue?vue&type=script&lang=js"

import "./AccessPage.vue?vue&type=style&index=0&id=79e52154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e52154"]])

export default __exports__